import {
    Environment,
    Network,
    RecordSource,
    Store,
} from 'relay-runtime';

import { currentScope, sessionChangedUnderThisTab, signInPathFor, signOut } from './helpers/accounts';

const API_URL = process.env.REACT_APP_API_URL || '';
const PUBLIC_PREFIXES = ["/catalogue"];
const PUBLIC_EXACT = [
  "/",
  "/sign-in",
  "/program/sign-in",
  "/program/forgot-password",
  "/sign-up",
  "/terms-of-use",
  "/privacy-policy",
  "/forgot-password",
  "/reset-password"
];

const isPublicPath = (pathname = window.location.pathname) => {
    if (PUBLIC_EXACT.includes(pathname)) return true;
    return PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

// Exported so the decision can be tested without driving a Relay environment.
export const signOutExpired = () => {
    const expired = currentScope();

    signOut();

    return signInPathFor(expired);
};

function fetchQuery(
    operation,
    variables,
) {
    if (sessionChangedUnderThisTab()) {
        window.location.reload();

        throw new Error('The signed-in account changed in another tab.');
    }

    const authToken = localStorage.getItem('authToken');

    const endpoint = `${API_URL}/graphql`.replace(/([^:]\/)\/+/g, '$1');
    return fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: authToken ? `Bearer ${authToken}` : ''
        },
        credentials: 'include',
        body: JSON.stringify({
            query: operation.text,
            variables,
        }),
    }).then(async (response) => {
        // If your server actually returns 401, keep this:
        if (response.status === 401) {
            window.location.href = signOutExpired();
            throw new Error("Session expired. Please log in again.");
        }

        const json = await response.json();

        // GraphQL-style auth failures: check errors, not `me`
        const unauthorized = json.errors?.some((e) =>
          (e.message || "").toLowerCase().includes("unauthorized")
        );

        if (unauthorized && !isPublicPath()) {
            window.location.href = signOutExpired();
            throw new Error("Unauthorized. Please log in again.");
        }

        return json;
    });
}

export const environment = new Environment({
    network: Network.create(fetchQuery),
    store: new Store(new RecordSource()),
});

export default environment;
